/* ============================================
   QUOTE WORKSTATION — Table Interactions
   Asset: workstation-table.js
   Custom item dropdown, table input/click delegation, collapsible sections, sticky notes
   ============================================ */
(function() {
  'use strict';
  var Q = window.QWS;
  if (!Q) return;
  var state = Q.state;
  var dom = Q.dom;
  var wrap = Q.wrap;
  var fmt = Q.fmt;
  var parseMoney = Q.parseMoney;
  var calculateDirect = Q.calculateDirect;
  var collapsedVendors = Q.collapsedVendors;
  var seriesQtyPropagated = Q.seriesQtyPropagated;

  /* ── Custom Item Dropdown ── */
  var customWrap = wrap.querySelector('.rq-ws-custom-add-wrap');
  var customBtn = wrap.querySelector('.rq-ws-search-bar__custom-btn');
  customBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    if (Q.bulkDrop) Q.bulkDrop.classList.remove('rq-ws-bulk-wrap__dropdown--open');
    customWrap.classList.toggle('rq-ws-custom-add-wrap--open');
  });
  var pendingCustomIds = [];
  customWrap.querySelector('.rq-ws-custom-add-dropdown').addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-count]');
    if (!btn) return;
    e.stopPropagation(); // keep dropdown open
    var count = parseInt(btn.getAttribute('data-add-count')) || 1;
    for (var i = 0; i < count; i++) {
      Q.addItem({
        type: 'custom',
        vendor: 'Custom',
        title: '',
        sku: '',
        quantity: 1,
        msrp: 0,
        cost: 0,
        points: 30,
        directPrice: 0,
        mapPrice: 0,
        _skipRender: true
      });
      pendingCustomIds.push(state.items[state.items.length - 1].id);
    }
    Q.renderItems();
  });
  document.addEventListener('click', function(e) {
    var anyOpen = customWrap.classList.contains('rq-ws-custom-add-wrap--open') ||
                  (Q.bulkDrop && Q.bulkDrop.classList.contains('rq-ws-bulk-wrap__dropdown--open')) ||
                  dom.loadDropdown.classList.contains('rq-ws-bar__load-dropdown--open');

    if (!customWrap.contains(e.target)) {
      var wasOpen = customWrap.classList.contains('rq-ws-custom-add-wrap--open');
      customWrap.classList.remove('rq-ws-custom-add-wrap--open');
      if (wasOpen && pendingCustomIds.length) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Swallow the dismissal click when it
           triggers the vendor prompt. Previously the outside-click that
           closed the Manual Entry dropdown ALSO ran whatever button it
           landed on (e.g. Save, a section toggle, a row action) before
           the vendor prompt appeared. Capture-phase + stopImmediatePropagation
           cancels the rest of the click pipeline so the first click is
           "just dismiss + open prompt"; clicks resume normal behavior
           after the prompt is dismissed. */
        e.preventDefault();
        e.stopImmediatePropagation();
        var ids = pendingCustomIds.slice();
        pendingCustomIds = [];
        Q.openVendorPrompt(ids);
        return;
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      }
    }

    // If a dropdown was open and click landed on a section toggle, block the toggle
    if (anyOpen && e.target.closest('.rq-ws-section__toggle')) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, true);

  /* ── Table Event Delegation ── */
  dom.itemsContainer.addEventListener('input', function(e) {
    var el = e.target;
    // Clear red validation immediately on keystroke
    el.classList.remove('rq-ws-table__input--missing', 'rq-ws-table__editable--missing');

    var itemId = el.getAttribute('data-item-id');
    var field = el.getAttribute('data-field');
    var subIdx = el.getAttribute('data-sub-idx');

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — a REPLACEMENT order is $0 to the
       customer, so it has no price to edit. Quantity and COST stay fully editable: the
       admin dials up what was damaged, and the cost is what the supplier PO is built
       from and what the company absorbs until the claim pays.

       The CSS in rep-quote-workstation.liquid greys these cells out; this catches the
       ways a pointer-events rule does not — keyboard tab-through, the arrow-key column
       navigation, and a paste into a focused cell. Neither is the guarantee: the server
       coerces points/directPrice to 0 on every save of an RPL-* ref. */
    if (state.isReplacement && (field === 'points' || field === 'directPrice' || field === 'msrp')) {
      el.value = '';
      return;
    }

    if (itemId && subIdx !== null && subIdx !== undefined && el.closest('.rq-ws-subdesc-row')) {
      // Sub-description edit — use data-sub-idx which maps to the correct array index
      var item = Q.findItem(itemId);
      if (item) {
        var idx = parseInt(subIdx);
        if (idx >= 0 && idx < item.subDescriptions.length) {
          var oldSd = item.subDescriptions[idx];
          item.subDescriptions[idx] = el.value;
          // Propagate shared vendor color sub edits to siblings
          // Duplicate items (same productHandle twice) never propagate — they configure independently.
          var editIsDup = false;
          if (item.productHandle) {
            for (var di = 0; di < state.items.length; di++) {
              if (state.items[di].id !== item.id && state.items[di].vendor === item.vendor && state.items[di].productHandle === item.productHandle) { editIsDup = true; break; }
            }
          }
          if (!editIsDup && Q.isVendorColorSubDesc(oldSd) && item.vendor) {
            var prefix = Q.subDescPrefix(oldSd);
            state.items.forEach(function(other) {
              if (other.id === item.id || other.vendor !== item.vendor) return;
              if (!other.subDescriptions) return;
              for (var si = 0; si < other.subDescriptions.length; si++) {
                if (Q.subDescPrefix(other.subDescriptions[si]) === prefix) {
                  other.subDescriptions[si] = el.value;
                  break;
                }
              }
            });
          }
        }
        /* Update the warning style. CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — the same
           predicate renderItems() uses, so a value typed over a real option ("Kickstand for Upright
           Storage: Maybe") goes amber as it is typed rather than only after the next re-render. */
        el.classList.toggle('rq-ws-subdesc--tbd', !!Q.subDescStatus(el.value, Q.optionMetaFor(item)));
        state.dirty = true;
      }
      return;
    }

    if (!itemId || !field) return;
    var item = Q.findItem(itemId);
    if (!item) return;

    var val = el.value;

    if (field === 'quantity') {
      item.quantity = Math.max(1, parseInt(val) || 1);
      var row = el.closest('tr');
      if (row) {
        var totalCell = row.querySelector('[data-field="totalDisplay"]');
        if (totalCell) {
          var lineTotal = item.isFree ? 0 : (item.directPrice || 0) * item.quantity;
          totalCell.innerHTML = item.isFree ? '<span style="color:var(--rq-success);">FREE</span>' : (lineTotal ? fmt(lineTotal) : '–');
        }
      }

      // Series qty logic: first entry propagates to all siblings, then individual only
      if (item.seriesId && !item.seriesIsPlates) {
        if (!seriesQtyPropagated[item.seriesId]) {
          // First qty entry for this series — propagate to all siblings
          seriesQtyPropagated[item.seriesId] = true;
          state.items.forEach(function(si) {
            if (si.seriesId === item.seriesId) {
              si.quantity = item.quantity;
            }
          });
          Q.renderItems();
          return;
        }
        // After initial propagation, only this item is affected (already set above)
      }

      Q.recalcTotals();
    } else if (field === 'cost') {
      item.cost = parseMoney(val);
      item.directPrice = calculateDirect(item.cost, item.points);
      Q.liveFmtMoney(el);
      var row = el.closest('tr');
      if (row) {
        var directCell = row.querySelector('[data-field="directDisplay"]');
        if (directCell) {
          var overMap = !item.isFree && item.directPrice > 0 && item.mapPrice > 0 && item.directPrice > item.mapPrice;
          var dHtml = item.isFree ? '<span style="color:var(--rq-success);">FREE</span>' : (item.directPrice ? fmt(item.directPrice) : '–');
          if (overMap && !item.isFree && item.directPrice) dHtml = '<span style="outline:1px solid var(--rq-error);outline-offset:2px;border-radius:3px;padding:1px 3px;">' + dHtml + '</span>';
          directCell.innerHTML = dHtml;
        }
        var totalCell = row.querySelector('[data-field="totalDisplay"]');
        if (totalCell) {
          var lineTotal = item.isFree ? 0 : item.directPrice * item.quantity;
          totalCell.innerHTML = item.isFree ? '<span style="color:var(--rq-success);">FREE</span>' : (lineTotal ? fmt(lineTotal) : '–');
        }
      }
      Q.recalcTotals();
    } else if (field === 'points') {
      item.points = parseFloat(val) || 0;
      item.directPrice = calculateDirect(item.cost, item.points);
      var row = el.closest('tr');
      if (row) {
        var directCell = row.querySelector('[data-field="directDisplay"]');
        if (directCell) {
          var overMap = !item.isFree && item.directPrice > 0 && item.mapPrice > 0 && item.directPrice > item.mapPrice;
          var dHtml = item.isFree ? '<span style="color:var(--rq-success);">FREE</span>' : (item.directPrice ? fmt(item.directPrice) : '–');
          if (overMap && !item.isFree && item.directPrice) dHtml = '<span style="outline:1px solid var(--rq-error);outline-offset:2px;border-radius:3px;padding:1px 3px;">' + dHtml + '</span>';
          directCell.innerHTML = dHtml;
        }
        var totalCell = row.querySelector('[data-field="totalDisplay"]');
        if (totalCell) {
          var lineTotal = item.isFree ? 0 : item.directPrice * item.quantity;
          totalCell.innerHTML = item.isFree ? '<span style="color:var(--rq-success);">FREE</span>' : (lineTotal ? fmt(lineTotal) : '–');
        }
      }
      Q.recalcTotals();
    } else if (field === 'msrp') {
      // Typing "-" marks the item as "N/A" (no MSRP) — sentinel value -1.
      // PDF renders "-" in the MSRP column; totals exclude these items.
      if (val.trim() === '-') {
        item.msrp = -1;
        el.value = '-';
      } else {
        var m = parseMoney(val);
        item.msrp = m < 0 ? 0 : m; // negatives can't reach the -1 sentinel via numeric path
        Q.liveFmtMoney(el);
      }
      Q.recalcTotals();
    } else if (field === 'seriesBaseTitle') {
      // Series title base — compose full title + propagate to siblings
      item.seriesBaseTitle = val;
      item.title = val ? (val + ' – ' + item.seriesWeight + ' lbs') : '';
      state.dirty = true;
      state.items.forEach(function(si) {
        if (si.seriesId !== item.seriesId || si.id === item.id) return;
        si.seriesBaseTitle = val;
        si.title = val ? (val + ' – ' + si.seriesWeight + ' lbs') : '';
        var inp = dom.itemsContainer.querySelector('tr[data-item-id="' + si.id + '"] [data-field="seriesBaseTitle"]');
        if (inp) inp.value = val;
      });
    } else if (field === 'seriesSku') {
      // Series SKU — detect weight number in typed value, propagate pattern to siblings
      item.sku = val;
      state.dirty = true;
      Q.propagateSeriesSku(item, val);
    } else if (field === 'title') {
      item.title = val;
      state.dirty = true;
    } else if (field === 'sku') {
      item.sku = val;
      state.dirty = true;
    }

    // SKU auto-resolve: when the rep edits a product item's SKU, look up the
    // matching variant in the catalog and swap variantId/cost/mapPrice/msrp so
    // both the PDF and the Shopify checkout link follow the new SKU. Triggered
    // on input but debounced — actual swap fires after the user stops typing.
    if (field === 'sku' && item.type === 'product' && item.productHandle) {
      Q.scheduleSkuResolve(item.id, val);
    }

    // If the row is now fully empty, clear all stale red outlines immediately
    if (item && item.type === 'custom') {
      var tv = item.seriesId ? (item.seriesBaseTitle || '') : (item.title || '');
      if (!tv && !item.sku && !(item.msrp > 0) && !(item.cost > 0) && !(item.quantity > 1)) {
        var row = el.closest('tr[data-item-id]');
        if (row) row.querySelectorAll('.rq-ws-table__input--missing, .rq-ws-table__editable--missing').forEach(function(r) { r.classList.remove('rq-ws-table__input--missing', 'rq-ws-table__editable--missing'); });
      }
    }
  });

  /* CUSTOM_RFQPORTAL_BY_CLAUDE — Custom-item SKU autofill from KV catalog.
     When the rep finishes typing a SKU on a custom (manual-entry) row,
     hit /custom-catalog-lookup. If the SKU is known, autofill any blank
     field (vendor / title / msrp / cost / points) without clobbering
     edits the rep already made. Toast confirms the autofill.

     Triggers on focusout (which bubbles, unlike blur). Same-SKU repeats
     are de-duped via a per-input flag so leaving and re-entering the
     field without changing the SKU doesn't re-fetch.

     Skipped for product-typed items (those use the catalog auto-resolve
     at line 246) and series-SKU rows (own propagation). */
  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — ⛔ A CARTON PRODUCT SNAPS UP TO WHOLE CARTONS.
     Heritage Motivate sells only in cartons of 12 planks / 24 sq ft (workstation-core.js
     UNIT_TOGGLE_PRODUCTS.piecesPerCarton); Ryan: *"if they tried to sell 23, it wouldn't let them."*
     On `change` (blur / Enter), NOT `input` — snapping per keystroke would turn a typed "2" into 12
     before the rep reached the "4". The row total is redrawn the way the input handler draws it;
     `renderItems` is deliberately not called so focus stays where the rep left it. The save gate
     in workstation-save.js is the second lock, for a value that never blurred. */
  dom.itemsContainer.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.getAttribute('data-field') !== 'quantity') return;
    var itemId = el.getAttribute('data-item-id');
    var item = itemId && Q.findItem(itemId);
    if (!item) return;
    var step = Q.cartonStepFor ? Q.cartonStepFor(item) : 0;
    if (!(step > 1)) return;
    var typed = Math.max(1, parseInt(el.value, 10) || 1);
    var snapped = Math.ceil(typed / step) * step;
    if (snapped === typed) return;
    item.quantity = snapped;
    el.value = String(snapped);
    var row = el.closest('tr');
    var totalCell = row && row.querySelector('[data-field="totalDisplay"]');
    if (totalCell) {
      var lineTotal = item.isFree ? 0 : (item.directPrice || 0) * item.quantity;
      totalCell.innerHTML = item.isFree ? '<span style="color:var(--rq-success);">FREE</span>' : (lineTotal ? fmt(lineTotal) : '–');
    }
    state.dirty = true;
    Q.updateSaveButton && Q.updateSaveButton();
    Q.recalcTotals && Q.recalcTotals();
    var unitWord = item.unitMode === 'sqft' ? 'sq ft' : 'planks';
    Q.showToast && Q.showToast('Sold by the carton only: ' + typed + ' ' + unitWord + ' rounded up to ' + snapped + ' (cartons of ' + step + ' ' + unitWord + ')', 'info', 3200);
  });
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  dom.itemsContainer.addEventListener('focusout', function (e) {
    var el = e.target;
    if (!el || el.getAttribute('data-field') !== 'sku') return;
    var itemId = el.getAttribute('data-item-id');
    if (!itemId) return;
    var item = Q.findItem(itemId);
    if (!item || item.type !== 'custom') return;
    var sku = String(el.value || '').trim();
    if (!sku) return;
    if (el._lastCatalogLookup === sku.toLowerCase()) return;
    el._lastCatalogLookup = sku.toLowerCase();
    Q.API.get('/custom-catalog-lookup?sku=' + encodeURIComponent(sku))
      .then(function (data) {
        if (!data || !data.entry) return;
        var entry = data.entry;
        var changed = false;
        if (!item.vendor && entry.vendor) { item.vendor = entry.vendor; changed = true; }
        if (!item.title && entry.title) { item.title = entry.title; changed = true; }
        if ((!item.msrp || item.msrp === 0) && entry.msrp > 0) { item.msrp = entry.msrp; changed = true; }
        if ((!item.cost || item.cost === 0) && entry.cost > 0) { item.cost = entry.cost; changed = true; }
        if ((!item.points || item.points === 0) && entry.points > 0) {
          item.points = entry.points;
          changed = true;
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Recompute directPrice
           from final cost + points after BOTH autofill branches run. Previously
           this lived inside the points branch only, so when the rep had already
           typed points (default 30%, etc.) before entering the SKU, the catalog
           cost would land but Direct + Total stayed blank — only retyping cost
           manually hit the cost-input handler's recompute (workstation-items.js
           ~L167). Mirrors that handler's behavior here. */
        if (item.cost > 0 && item.points > 0 && Q.calculateDirect) {
          item.directPrice = Q.calculateDirect(item.cost, item.points);
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        if (changed) {
          state.dirty = true;
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-16) — was a bare Q.renderItems(), which threw
             the rep to the top of the quote every time a remembered SKU filled itself in. The
             rebuild destroys the cell they had just tabbed into, and the browser scroll-snaps to
             whatever it focuses next. renderItemsInPlace restores both the scroll position and the
             focused cell. */
          if (Q.renderItemsInPlace) Q.renderItemsInPlace(); else Q.renderItems();
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          if (Q.recalcTotals) Q.recalcTotals();
          if (Q.showToast) Q.showToast('Loaded from custom catalog: ' + (entry.title || sku), 'success');
        }
      })
      .catch(function () { /* non-fatal — leave row untouched */ });
  });
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Excel-style arrow-key
     navigation between item-row cells. Six logical columns per item row:
     title (or seriesBaseTitle) → sku (or seriesSku) → qty → msrp → cost →
     points. MAP / Direct / Total are derived (no input) — skipped naturally.

     - ↑ / ↓: move to same column in the prev/next visible item row.
       Select-all on land so typing overwrites (Excel-style).
     - ← / →: only navigate when caret is at start/end of the current
       input — preserves normal in-cell text editing otherwise. Cursor
       lands at the natural end (← → end of left neighbour, → → start
       of right neighbour).
     - Skips collapsed vendor-group rows via offsetParent check.
     - Overrides the native qty-input ↑/↓ increment behavior so the row
       nav wins on number fields too. */
  var NAV_COLS = [
    ['title', 'seriesBaseTitle'],
    ['sku', 'seriesSku'],
    ['quantity'],
    ['msrp'],
    ['cost'],
    ['points'],
  ];
  function _navColIdx(field) {
    for (var i = 0; i < NAV_COLS.length; i++) {
      if (NAV_COLS[i].indexOf(field) !== -1) return i;
    }
    return -1;
  }
  function _navInputInRow(row, colIdx) {
    if (!row) return null;
    var aliases = NAV_COLS[colIdx];
    for (var i = 0; i < aliases.length; i++) {
      var inp = row.querySelector('input[data-field="' + aliases[i] + '"]');
      if (inp && inp.offsetParent !== null) return inp;
    }
    return null;
  }
  function _navVerticalTarget(row, colIdx, direction) {
    var rows = Array.prototype.slice.call(dom.itemsContainer.querySelectorAll('tr[data-item-id]'));
    var idx = rows.indexOf(row);
    if (idx < 0) return null;
    for (var i = idx + direction; i >= 0 && i < rows.length; i += direction) {
      if (rows[i].offsetParent === null) continue;
      var inp = _navInputInRow(rows[i], colIdx);
      if (inp) return inp;
    }
    return null;
  }
  function _navHorizontalTarget(row, colIdx, direction) {
    for (var i = colIdx + direction; i >= 0 && i < NAV_COLS.length; i += direction) {
      var inp = _navInputInRow(row, i);
      if (inp) return inp;
    }
    return null;
  }
  function _navCaretAtStart(el) {
    if (el.type === 'number') return true; // selectionStart unsupported; treat as edge
    try { return el.selectionStart === 0 && el.selectionEnd === 0; } catch (_) { return true; }
  }
  function _navCaretAtEnd(el) {
    if (el.type === 'number') return true;
    try { return el.selectionStart === el.value.length && el.selectionEnd === el.value.length; } catch (_) { return true; }
  }
  function _navFocusAndSelect(el) {
    el.focus();
    try { el.select(); } catch (_) {}
  }
  function _navFocusAt(el, position) {
    el.focus();
    var len = (el.value || '').length;
    var pos = position === 'end' ? len : 0;
    try { el.setSelectionRange(pos, pos); } catch (_) {}
  }
  dom.itemsContainer.addEventListener('keydown', function(e) {
    if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var el = e.target;
    if (!el || el.tagName !== 'INPUT') return;
    var field = el.getAttribute('data-field');
    if (!field) return; // sub-desc and other non-table inputs
    var colIdx = _navColIdx(field);
    if (colIdx < 0) return;
    var row = el.closest('tr[data-item-id]');
    if (!row) return;
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      var up = _navVerticalTarget(row, colIdx, -1);
      if (up) _navFocusAndSelect(up);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      var down = _navVerticalTarget(row, colIdx, 1);
      if (down) _navFocusAndSelect(down);
    } else if (e.key === 'ArrowLeft') {
      if (!_navCaretAtStart(el)) return;
      e.preventDefault();
      var left = _navHorizontalTarget(row, colIdx, -1);
      if (left) _navFocusAt(left, 'end');
    } else if (e.key === 'ArrowRight') {
      if (!_navCaretAtEnd(el)) return;
      e.preventDefault();
      var right = _navHorizontalTarget(row, colIdx, 1);
      if (right) _navFocusAt(right, 'start');
    }
  });
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  /* ── Sub-description keyboard shortcuts ──
     Enter → add a new sub-line below the current one and focus it.
     Backspace on empty sub-line → remove it and focus the previous row.
     Both work by dispatching click on the existing addmore/remove buttons
     so the insert/remove logic stays in one place. */
  dom.itemsContainer.addEventListener('keydown', function(e) {
    var el = e.target;
    if (!el || el.tagName !== 'INPUT') return;
    if (el.getAttribute('data-sub-idx') === null) return;
    var subRow = el.closest('.rq-ws-subdesc-row');
    if (!subRow) return;

    if (e.key === 'Enter') {
      e.preventDefault();
      var addBtn = subRow.querySelector('.rq-ws-subdesc-addmore');
      if (addBtn) addBtn.click();
      return;
    }

    if (e.key === 'Backspace' && el.value === '') {
      e.preventDefault();
      var prevRow = subRow.previousElementSibling;
      while (prevRow && !prevRow.classList.contains('rq-ws-subdesc-row')) {
        prevRow = prevRow.previousElementSibling;
      }
      var removeBtn = subRow.querySelector('.rq-ws-subdesc-remove');
      if (removeBtn) removeBtn.click();
      if (prevRow) {
        var prevInp = prevRow.querySelector('input');
        if (prevInp) {
          prevInp.focus();
          var len = prevInp.value.length;
          try { prevInp.setSelectionRange(len, len); } catch (_) {}
        }
      }
      return;
    }
  });

  /* ── Table Click Delegation ── */
  dom.itemsContainer.addEventListener('click', function(e) {
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-16) — Vendor group up/down reorder.

       Matched FIRST, and stops propagation, so the vendor-header collapse branch below never sees
       the click (the arrows live inside [data-vendor-toggle]).

       WHAT MOVES: vendor order on this quote is not stored anywhere — it is the order each vendor
       FIRST appears in state.items (workstation-items.js groups on the fly, and freight's
       getUniqueVendors derives the same way, so the freight table follows along). So the move
       rebuilds state.items as whole per-vendor blocks with two of them swapped. That also
       de-interleaves a vendor whose rows were scattered through the array, which is what the
       screen was already showing.

       WHY THE SCROLL MATH: renderItems() rebuilds every group, and the swapped neighbour is almost
       never the same height, so the clicked group would otherwise jump. Measure the group's
       viewport top before, measure the new node's top after, scroll by the difference — the rep
       sees everything else slide around a group that never moved. The page can run out of scroll
       at the very top or bottom; there it lands as close as the document allows. */
    var mvBtn = e.target.closest('[data-vendor-move]');
    if (mvBtn) {
      e.stopPropagation();
      if (mvBtn.disabled) return;
      var mvVendor = mvBtn.getAttribute('data-move-vendor') || '';
      var mvDir = mvBtn.getAttribute('data-vendor-move') === 'up' ? -1 : 1;
      var mvGroup = mvBtn.closest('.rq-ws-vendor-group');
      var mvAnchorTop = mvGroup ? mvGroup.getBoundingClientRect().top : null;

      /* Same reason the +5 and remove-X handlers blur: the button is about to be destroyed by the
         re-render, and the browser would hand focus to the next focusable element and scroll to it. */
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }

      var mvOrder = [];
      var mvBlocks = {};
      state.items.forEach(function(it) {
        var v = it.vendor || 'Other';
        if (!mvBlocks[v]) { mvBlocks[v] = []; mvOrder.push(v); }
        mvBlocks[v].push(it);
      });
      var mvFrom = mvOrder.indexOf(mvVendor);
      var mvTo = mvFrom + mvDir;
      if (mvFrom < 0 || mvTo < 0 || mvTo >= mvOrder.length) return;
      mvOrder.splice(mvTo, 0, mvOrder.splice(mvFrom, 1)[0]);

      var mvRebuilt = [];
      mvOrder.forEach(function(v) { mvRebuilt = mvRebuilt.concat(mvBlocks[v]); });
      /* Mutate in place — other modules hold a reference to this array. */
      state.items.length = 0;
      Array.prototype.push.apply(state.items, mvRebuilt);
      state.dirty = true;

      Q.renderItems();

      if (mvAnchorTop !== null) {
        var mvHeaders = dom.itemsContainer.querySelectorAll('[data-vendor-toggle]');
        var mvNew = null;
        for (var mvi = 0; mvi < mvHeaders.length; mvi++) {
          if (mvHeaders[mvi].getAttribute('data-vendor-toggle') === mvVendor) {
            mvNew = mvHeaders[mvi].closest('.rq-ws-vendor-group');
            break;
          }
        }
        if (mvNew) {
          var mvDelta = mvNew.getBoundingClientRect().top - mvAnchorTop;
          if (mvDelta) window.scrollBy(0, mvDelta);
        }
      }
      return;
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Vendor "+5" quick-add. Matched first
       so the header-collapse branch below skips it (data-vendor-toggle is
       on the parent header). Adds 5 blank custom rows pre-tagged with
       the vendor; no vendor prompt needed since the vendor is implied
       by the button's location.

       'Other' caveat: workstation-items.js groups items with empty
       vendor under a synthesized 'Other' header (no item actually has
       vendor='Other'). For the +5 button on that group, leave new rows'
       vendor empty so they join the same Other group instead of forking
       off into a literal 'Other' vendor that wouldn't collapse-merge. */
    var addnBtn = e.target.closest('[data-vendor-addn]');
    if (addnBtn) {
      e.stopPropagation();
      var addnVendorRaw = addnBtn.getAttribute('data-vendor-addn') || '';
      var addnVendor = (addnVendorRaw === 'Other') ? '' : addnVendorRaw;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Blur + preserve scrollY around the
         renderItems() rebuild. Same pattern the remove-X handler uses —
         without it the +5 button is destroyed by innerHTML replacement
         and the browser focus-jumps to the next focusable element,
         snapping the page scroll up. */
      var _scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
      for (var ai = 0; ai < 5; ai++) {
        Q.addItem({
          type: 'custom',
          vendor: addnVendor,
          title: '',
          sku: '',
          quantity: 1,
          msrp: 0,
          cost: 0,
          points: 30,
          directPrice: 0,
          mapPrice: 0,
          _skipDupCheck: true,
          _skipRender: true,
        });
      }
      Q.renderItems();
      state.dirty = true;
      window.scrollTo(0, _scrollY);
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      return;
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    // Vendor header click — collapse/expand (unless clicking the name/pencil button)
    var header = e.target.closest('[data-vendor-toggle]');
    if (header && !e.target.closest('.rq-ws-vendor-group__name')) {
      var v = header.getAttribute('data-vendor-toggle');
      collapsedVendors[v] = !collapsedVendors[v];
      var group = header.closest('.rq-ws-vendor-group');
      var body = group ? group.querySelector('.rq-ws-vendor-group__body') : null;
      var colBtn = header.querySelector('.rq-ws-vendor-group__collapse');
      if (body) body.classList.toggle('rq-ws-vendor-group__body--collapsed', collapsedVendors[v]);
      if (colBtn) {
        colBtn.innerHTML = collapsedVendors[v] ? '+' : '&minus;';
        colBtn.style.animation = 'none';
        colBtn.offsetHeight; // force reflow
        colBtn.style.animation = 'rq-spin-once 0.35s ease';
      }
      return;
    }

    var btn = e.target.closest('button');
    if (!btn) return;

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Per-item external product-link editor
       (PDF product-links feature). Add/Edit reveal the inline input; Save/Clear
       persist by SKU to /product-external-link (reused on future quotes); the
       Blue Sky storefront page still wins automatically on the PDF. */
    if (btn.classList.contains('rq-ws-extlink__add') || btn.classList.contains('rq-ws-extlink__edit') || btn.classList.contains('rq-ws-extlink__chip--manual')) {
      var _elWrap = btn.closest('.rq-ws-extlink');
      if (_elWrap) {
        // Hide the trigger row (Add button / External-link pill) and reveal the
        // inline editor. Clicking the manual pill IS how you edit it now.
        ['__add', '__chip', '__edit', '__clear', '__hint'].forEach(function(c) {
          var el = _elWrap.querySelector('.rq-ws-extlink' + c);
          if (el) el.style.display = 'none';
        });
        var _ed = _elWrap.querySelector('.rq-ws-extlink__editor');
        if (_ed) { _ed.style.display = 'flex'; var _inp = _ed.querySelector('.rq-ws-extlink__input'); if (_inp) { _inp.focus(); _inp.select(); } }
      }
      return;
    }
    if (btn.classList.contains('rq-ws-extlink__cancel')) {
      Q.renderItems();
      return;
    }
    if (btn.classList.contains('rq-ws-extlink__save') || btn.classList.contains('rq-ws-extlink__clear') || btn.classList.contains('rq-ws-extlink__delete')) {
      var _w = btn.closest('.rq-ws-extlink');
      if (!_w) return;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Custom (manual-entry) items store their link
         ON the item (persisted with the quote in workstation_meta), not the shared
         per-SKU map. Handle them here and skip the SKU-keyed admin POST below. */
      if (_w.getAttribute('data-custom')) {
        var _custId = _w.getAttribute('data-item-id');
        var _custItem = null;
        for (var _ci = 0; _ci < state.items.length; _ci++) { if (state.items[_ci].id === _custId) { _custItem = state.items[_ci]; break; } }
        if (!_custItem) return;
        var _custClear = btn.classList.contains('rq-ws-extlink__clear') || btn.classList.contains('rq-ws-extlink__delete');
        var _custInEl = _w.querySelector('.rq-ws-extlink__input');
        var _custUrlVal = _custClear ? '' : ((_custInEl && _custInEl.value) || '').trim();
        if (!_custClear && _custUrlVal && !/^https?:\/\//i.test(_custUrlVal)) {
          if (Q.showToast) Q.showToast('Link must start with http:// or https://', 'error');
          return;
        }
        _custItem.externalLink = _custUrlVal;
        state.dirty = true;
        Q.renderItems();
        if (Q.showToast) Q.showToast(_custClear ? 'Product link removed.' : 'Product link saved.', 'success');
        return;
      }
      var _sku = _w.getAttribute('data-sku') || '';
      if (!_sku) { if (Q.showToast) Q.showToast('Add a SKU to this item before linking it.', 'error'); return; }
      // Delete (in-editor) replaces the old always-visible × — same clear action.
      var _clearing = btn.classList.contains('rq-ws-extlink__clear') || btn.classList.contains('rq-ws-extlink__delete');
      var _inEl = _w.querySelector('.rq-ws-extlink__input');
      var _url = _clearing ? '' : ((_inEl && _inEl.value) || '').trim();
      if (!_clearing && _url && !/^https?:\/\//i.test(_url)) {
        if (Q.showToast) Q.showToast('Link must start with http:// or https://', 'error');
        return;
      }
      // A weight sequence shows ONE control but the PDF links every weight row,
      // so propagate the save/delete to every member SKU of the series. Plain
      // items just target their own SKU.
      var _seriesId = _w.getAttribute('data-series-id') || '';
      var _targetSkus = [_sku];
      if (_seriesId) {
        _targetSkus = [];
        (state.items || []).forEach(function(it) {
          if (it.seriesId === _seriesId && it.sku && _targetSkus.indexOf(it.sku) === -1) _targetSkus.push(it.sku);
        });
        if (!_targetSkus.length) _targetSkus = [_sku];
      }
      btn.disabled = true;
      var _api = Q.API || (window.RepPortal && window.RepPortal.API);
      Promise.all(_targetSkus.map(function(s) {
        return _api.post('/product-external-link', { sku: s, url: _url }).then(function(resp) {
          if (resp && resp.success !== false) {
            if (!state.externalLinks) state.externalLinks = {};
            if (_url) state.externalLinks[s] = _url; else delete state.externalLinks[s];
            return true;
          }
          throw new Error((resp && resp.error) || 'unknown error');
        });
      })).then(function() {
        Q.renderItems();
        if (Q.showToast) Q.showToast(_clearing ? 'Product link removed.' : 'Product link saved.', 'success');
      }).catch(function(err) {
        btn.disabled = false;
        if (Q.showToast) Q.showToast('Failed to save link: ' + (err && err.message ? err.message : 'unknown error'), 'error');
      });
      return;
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Vendor name pencil — open rename prompt
    if (btn.classList.contains('rq-ws-vendor-group__name')) {
      var oldVendor = btn.getAttribute('data-vendor');
      var ids = [];
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — 'Other' is a synthesized group label
         for items with empty/null vendor — no item actually carries
         vendor='Other'. Direct equality match (i.vendor === 'Other')
         would find zero items and the rename would silently no-op.
         Match by absence-of-vendor instead so renaming Other → real
         name works. */
      if (oldVendor === 'Other') {
        state.items.forEach(function(i) { if (!i.vendor) ids.push(i.id); });
      } else {
        state.items.forEach(function(i) { if (i.vendor === oldVendor) ids.push(i.id); });
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      Q.openVendorPrompt(ids);
      return;
    }

    var itemId = btn.getAttribute('data-item-id');

    // Remove item
    if (btn.classList.contains('rq-ws-table__remove-btn') && itemId) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Blur active button + snapshot scrollY
         before Q.renderItems() rebuilds the items container. innerHTML
         replacement destroys the focused remove button; without a blur
         the browser focuses the next focusable element and scroll-snaps
         to it (often jumping the rep up the page). Same pattern used by
         the dashboard's rerenderDetail helper. */
      var _scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
      state.items = state.items.filter(function(i) { return i.id !== itemId; });
      Q.renderItems();
      Q.validateAllRows();
      window.scrollTo(0, _scrollY);
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      return;
    }

    // Toggle in-house / no-freight on a line item — the item still appears on
    // the customer-facing quote, but the freight email's items table skips it.
    if (btn.classList.contains('rq-ws-table__no-freight') && itemId) {
      var nfItem = Q.findItem(itemId);
      if (nfItem) {
        nfItem.excludeFromFreight = !nfItem.excludeFromFreight;
        state.dirty = true;
        Q.renderItems();
      }
      return;
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Unit-toggle (per-piece ↔ per-sq-ft) pill
       on the item row. Scales qty/msrp/cost by the product's conversion
       factor (e.g. 2 sq ft per Heritage Motivate plank). Points stays
       unchanged (margin %, scale-invariant), so the Direct column
       auto-recomputes via the standard engine and the line total in dollars
       is preserved across the toggle. Sub-text "Quoted as planks" gets
       swapped for "Quoted as sq ft" (or vice versa); a plank-count summary
       line is appended in sq-ft mode so the physical purchase qty stays
       visible to the rep. */
    if (btn.classList.contains('rq-ws-unit-toggle__btn') && itemId) {
      var utItem = Q.findItem(itemId);
      if (!utItem) return;
      var utCfg = Q.getUnitToggleConfig && Q.getUnitToggleConfig(utItem);
      if (!utCfg) return;

      var k = utCfg.sqFtPerPiece || 1;
      var toSqft = utItem.unitMode !== 'sqft';
      // Capture piece-count BEFORE we scale, for the parenthetical summary
      // line. In sqft → piece direction, the current qty IS sq ft, so the
      // piece count is qty / k.
      var pieceCountBefore = toSqft ? (utItem.quantity || 0) : Math.round((utItem.quantity || 0) / k);

      if (toSqft) {
        utItem.quantity = Math.max(1, Math.round((utItem.quantity || 0) * k));
        if (utItem.msrp && utItem.msrp !== -1) utItem.msrp = utItem.msrp / k;
        if (utItem.cost) utItem.cost = utItem.cost / k;
        utItem.unitMode = 'sqft';
      } else {
        utItem.quantity = Math.max(1, Math.round((utItem.quantity || 0) / k));
        if (utItem.msrp && utItem.msrp !== -1) utItem.msrp = utItem.msrp * k;
        if (utItem.cost) utItem.cost = utItem.cost * k;
        utItem.unitMode = 'piece';
      }
      // Direct auto-rebuilds from cost + points on next render — see the
      // recalc in this same delegation block + the renderer's derived cells.
      if (utItem.cost > 0 && utItem.points > 0) {
        utItem.directPrice = Q.calculateDirect(utItem.cost, utItem.points);
      }

      // Rewrite "Quoted as" sub-text. Swap whichever side currently exists,
      // append if neither exists. Also manage a parenthetical plank-count
      // line so the physical purchase qty stays readable in sqft mode.
      if (!utItem.subDescriptions) utItem.subDescriptions = [];
      var subs = utItem.subDescriptions;
      var pieceLabel = (pieceCountBefore === 1) ? utCfg.pieceLabelSingular : utCfg.pieceLabelPlural;
      var pieceCountLine = '(' + pieceCountBefore + ' ' + pieceLabel + ' total)';
      // Drop any prior "Quoted as ..." + prior "(N planks total)" lines
      var pieceCountRe = /^\(\d+\s+(plank|tile|paver|piece)s?\s+total\)$/i;
      utItem.subDescriptions = subs.filter(function(sd) {
        return sd.indexOf('Quoted as') !== 0 && !pieceCountRe.test(sd);
      });
      // Prepend fresh "Quoted as" line, then summary line in sqft mode
      utItem.subDescriptions.unshift(toSqft ? utCfg.quotedAsSqft : utCfg.quotedAsPiece);
      if (toSqft) {
        utItem.subDescriptions.splice(1, 0, pieceCountLine);
      }

      state.dirty = true;
      Q.updateSaveButton && Q.updateSaveButton();
      Q.renderItems();
      Q.recalcTotals();
      Q.showToast && Q.showToast('Switched to ' + (toSqft ? 'sq ft' : utCfg.pieceLabelPlural), 'success', 1800);
      return;
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Config indicator click — open/close inline picker
    if ((btn.classList.contains('rq-ws-item-config-indicator') || btn.classList.contains('rq-ws-tbd-configure') || btn.classList.contains('rq-ws-options-pill')) && itemId) {
      var slot = dom.itemsContainer.querySelector('.rq-ws-inline-picker-slot[data-item-id="' + itemId + '"]');
      if (!slot) return;
      // Toggle: if already has a picker, close it
      var existingPicker = slot.querySelector('.rq-ws-inline-picker');
      if (existingPicker) {
        existingPicker.remove();
        if (Q.searchBackdrop) Q.searchBackdrop.classList.remove('rq-ws-search-backdrop--open');
        // Reset vendor group z-index
        var vg = btn.closest('.rq-ws-vendor-group');
        if (vg) vg.style.zIndex = '';
        return;
      }
      // Close any other open inline pickers
      var allPickers = dom.itemsContainer.querySelectorAll('.rq-ws-inline-picker');
      for (var pi = 0; pi < allPickers.length; pi++) allPickers[pi].remove();
      // Reset all vendor group z-indexes
      dom.itemsContainer.querySelectorAll('.rq-ws-vendor-group').forEach(function(g) { g.style.zIndex = ''; });
      // Elevate this vendor group above backdrop + show backdrop
      var vendorGroup = btn.closest('.rq-ws-vendor-group');
      if (vendorGroup) { vendorGroup.style.position = 'relative'; vendorGroup.style.zIndex = '95'; }
      if (Q.searchBackdrop) Q.searchBackdrop.classList.add('rq-ws-search-backdrop--open');
      // Build and insert picker
      var configItem = Q.findItem(itemId);
      /* CUSTOM_QWOPTIONS_BY_CLAUDE (Ryan 2026-08-24) — a pill click means "configure THIS line".

         The picker's default is to hide an option whose colour is shared across the vendor group on
         every row but the last, so the panel mirrors where the collapsed colour prints on the PDF.
         That is right for a picker you reach FROM the last row, and hostile for a button sitting on
         every row: click Options on the first of three Legend lines and Frame Color simply would not
         be there. The pill therefore asks for all of them. Applying still propagates a shared colour
         across the group exactly as before, so what prints does not change — only what is reachable. */
      if (configItem) Q.buildInlineConfigPicker(configItem, slot, { allOptions: btn.classList.contains('rq-ws-options-pill') });
      return;
    }

    // Toggle sub-description area
    if (btn.classList.contains('rq-ws-subdesc-toggle') && itemId) {
      clearTimeout(Q.subdescBlurTimer);
      var area = dom.itemsContainer.querySelector('.rq-ws-subdesc-area[data-item-id="' + itemId + '"]');
      if (area) {
        var isOpen = area.classList.contains('rq-ws-subdesc-area--open');
        if (isOpen) {
          // Clean up empties before closing
          var item = Q.findItem(itemId);
          if (item && item.subDescriptions) {
            var rows = area.querySelectorAll('.rq-ws-subdesc-row');
            for (var ri = rows.length - 1; ri >= 0; ri--) {
              var inp = rows[ri].querySelector('input');
              if (inp && ri < item.subDescriptions.length && item.subDescriptions[ri] === '') {
                item.subDescriptions.splice(ri, 1);
                rows[ri].remove();
              }
            }
          }
          area.classList.remove('rq-ws-subdesc-area--open');
          btn.classList.remove('rq-ws-subdesc-toggle--open');
          btn.textContent = '⋯';
        } else {
          area.classList.add('rq-ws-subdesc-area--open');
          btn.classList.add('rq-ws-subdesc-toggle--open');
          btn.textContent = '⋯';
          // If no visible sub-description rows, auto-add a blank one
          var item = Q.findItem(itemId);
          var existingRows = area.querySelectorAll('.rq-ws-subdesc-row');
          if (item && existingRows.length === 0) {
            if (!item.subDescriptions) item.subDescriptions = [];
            item.subDescriptions.push('');
            state.dirty = true;
            var si = item.subDescriptions.length - 1;
            var row = document.createElement('div');
            row.className = 'rq-ws-subdesc-row';
            row.innerHTML = '<button class="rq-ws-subdesc-addmore" data-item-id="' + itemId + '" type="button">⋯</button><input value="" data-item-id="' + itemId + '" data-sub-idx="' + si + '" spellcheck="false"><button class="rq-ws-subdesc-remove" data-item-id="' + itemId + '" data-sub-idx="' + si + '" type="button">&times;</button>';
            var tbdBtn = area.querySelector('.rq-ws-tbd-configure');
            if (tbdBtn) area.insertBefore(row, tbdBtn);
            else area.appendChild(row);
            row.querySelector('input').focus();
            if (Q.refreshSubdescHandles) Q.refreshSubdescHandles(area);
          }
        }
      }
      return;
    }

    // Add another sub-description (ellipsis button on each row)
    if (btn.classList.contains('rq-ws-subdesc-addmore') && itemId) {
      clearTimeout(Q.subdescBlurTimer);
      var item = Q.findItem(itemId);
      if (item) {
        if (!item.subDescriptions) item.subDescriptions = [];
        // Find the index of the clicked row so we insert after it
        var clickedRow = btn.closest('.rq-ws-subdesc-row');
        var area = dom.itemsContainer.querySelector('.rq-ws-subdesc-area[data-item-id="' + itemId + '"]');
        var insertIdx = item.subDescriptions.length; // default: end
        if (clickedRow && area) {
          var allRows = area.querySelectorAll('.rq-ws-subdesc-row');
          for (var ri = 0; ri < allRows.length; ri++) {
            if (allRows[ri] === clickedRow) { insertIdx = ri + 1; break; }
          }
        }
        item.subDescriptions.splice(insertIdx, 0, '');
        state.dirty = true;
        if (area) {
          var row = document.createElement('div');
          row.className = 'rq-ws-subdesc-row';
          row.innerHTML = '<button class="rq-ws-subdesc-addmore" data-item-id="' + itemId + '" type="button">⋯</button><input value="" data-item-id="' + itemId + '" data-sub-idx="' + insertIdx + '" spellcheck="false"><button class="rq-ws-subdesc-remove" data-item-id="' + itemId + '" data-sub-idx="' + insertIdx + '" type="button">&times;</button>';
          if (clickedRow && clickedRow.nextSibling) {
            area.insertBefore(row, clickedRow.nextSibling);
          } else {
            // Find the TBD configure button and insert before it, or append
            var tbdBtn = area.querySelector('.rq-ws-tbd-configure');
            if (tbdBtn) area.insertBefore(row, tbdBtn);
            else area.appendChild(row);
          }
          row.querySelector('input').focus();
          if (Q.refreshSubdescHandles) Q.refreshSubdescHandles(area);
        }
      }
      return;
    }

    // Remove sub-description
    if (btn.classList.contains('rq-ws-subdesc-remove') && itemId) {
      clearTimeout(Q.subdescBlurTimer);
      var item = Q.findItem(itemId);
      var subRow = btn.closest('.rq-ws-subdesc-row');
      if (item && item.subDescriptions && subRow) {
        // Find actual index by row position among siblings
        var area = subRow.closest('.rq-ws-subdesc-area');
        var allRows = area ? area.querySelectorAll('.rq-ws-subdesc-row') : [];
        var realIdx = -1;
        for (var ri = 0; ri < allRows.length; ri++) {
          if (allRows[ri] === subRow) { realIdx = ri; break; }
        }
        if (realIdx >= 0 && realIdx < item.subDescriptions.length) {
          item.subDescriptions.splice(realIdx, 1);
        }
        subRow.remove();
        state.dirty = true;
        if (area && Q.refreshSubdescHandles) Q.refreshSubdescHandles(area);
        // If none left, collapse area + reset toggle
        if (!item.subDescriptions.length) {
          var toggle = dom.itemsContainer.querySelector('.rq-ws-subdesc-toggle[data-item-id="' + itemId + '"]');
          if (area) area.classList.remove('rq-ws-subdesc-area--open');
          if (toggle) { toggle.classList.remove('rq-ws-subdesc-toggle--open'); toggle.textContent = '⋯'; }
        }
      }
      return;
    }


    // Set vendor points — open bulk modal pre-scoped to this vendor
    if (btn.classList.contains('rq-ws-vendor-group__set-pts')) {
      var vendor = btn.getAttribute('data-vendor');
      Q.openBulkModal('set-pts');
      // Pre-select this vendor's scope pill
      Q.bulkModalState.selectedScope = vendor;
      Q.bulkModalScope.querySelectorAll('.rq-ws-bulk-modal__scope-pill').forEach(function(p) {
        p.classList.toggle('rq-ws-bulk-modal__scope-pill--selected', p.getAttribute('data-scope') === vendor);
      });
      return;
    }
  });

  /* ── Note Popover ── */
  /* ── Collapsible Sections (+/- with 360 spin, scrollHeight animation) ── */
  function spinToggle(icon, newSymbol) {
    icon.style.animation = 'none';
    icon.offsetHeight;
    icon.style.animation = 'rq-spin-once 0.4s ease';
    setTimeout(function() { icon.textContent = newSymbol; }, 200);
  }
  var lastSectionToggle = null; // track last click for accordion behavior
  wrap.addEventListener('click', function(e) {
    // Any click that isn't a section toggle resets the accordion tracker
    if (!e.target.closest('.rq-ws-section__toggle')) lastSectionToggle = null;
  });
  wrap.querySelectorAll('.rq-ws-section__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var body = this.nextElementSibling;
      var icon = this.querySelector('.rq-ws-section__toggle-icon');
      var isOpen = body.classList.contains('rq-ws-section__body--open');

      // Accordion: if last click was a different section toggle, close that one
      if (lastSectionToggle && lastSectionToggle !== this && !isOpen) {
        var prevBody = lastSectionToggle.nextElementSibling;
        var prevIcon = lastSectionToggle.querySelector('.rq-ws-section__toggle-icon');
        if (prevBody && prevBody.classList.contains('rq-ws-section__body--open')) {
          prevBody.style.overflow = 'hidden';
          prevBody.style.maxHeight = prevBody.scrollHeight + 'px';
          prevBody.offsetHeight;
          prevBody.style.maxHeight = '0';
          prevBody.classList.remove('rq-ws-section__body--open');
          if (prevIcon) spinToggle(prevIcon, '+');
        }
      }
      lastSectionToggle = this;

      if (isOpen) {
        /* Collapse: lock overflow, set explicit scrollHeight first, then animate to 0 */
        body.style.overflow = 'hidden';
        body.style.maxHeight = body.scrollHeight + 'px';
        body.offsetHeight;
        body.style.maxHeight = '0';
        body.classList.remove('rq-ws-section__body--open');
      } else {
        /* Expand: ensure overflow hidden during animation, add class, measure, animate */
        body.style.overflow = 'hidden';
        body.classList.add('rq-ws-section__body--open');
        var targetH = body.scrollHeight;
        body.style.maxHeight = '0px';
        body.offsetHeight;
        body.style.maxHeight = targetH + 'px';
        var b = body;
        var onEnd = function() {
          b.style.maxHeight = 'none';
          b.style.overflow = 'visible';
          b.removeEventListener('transitionend', onEnd);
        };
        body.addEventListener('transitionend', onEnd);
      }
      if (icon) spinToggle(icon, isOpen ? '+' : '−');
    });
  });

  /* Set initial max-height for already-open sections */
  wrap.querySelectorAll('.rq-ws-section__body--open').forEach(function(body) {
    body.style.maxHeight = 'none';
    body.style.overflow = 'visible';
  });

  /* ── Sticky Notes Sidebar Toggle ── */
  var notesToggle = wrap.querySelector('.rq-ws-notes-sidebar__toggle');
  var notesHeader = wrap.querySelector('.rq-ws-notes-sidebar__header');
  var notesBody = wrap.querySelector('.rq-ws-notes-sidebar__body');
  var notesSidebar = wrap.querySelector('.rq-ws-notes-sidebar');
  if (notesHeader && notesToggle && notesBody) {
    notesBody.style.maxHeight = 'none';
    notesHeader.addEventListener('click', function() {
      var isCollapsed = notesBody.classList.contains('rq-ws-notes-sidebar__body--collapsed');

      if (isCollapsed) {
        /* Expand: remove collapsed class first so content is measurable */
        notesBody.classList.remove('rq-ws-notes-sidebar__body--collapsed');
        notesSidebar.classList.remove('rq-ws-notes-sidebar--collapsed');
        var fullH = notesBody.scrollHeight + 24;
        notesBody.style.maxHeight = '0';
        notesBody.offsetHeight;
        notesBody.style.maxHeight = fullH + 'px';
        var onEnd = function(ev) {
          if (ev.propertyName !== 'max-height') return;
          notesBody.style.maxHeight = 'none';
          notesBody.removeEventListener('transitionend', onEnd);
        };
        notesBody.addEventListener('transitionend', onEnd);
      } else {
        /* Collapse: lock current height, add collapsed class, then animate to 0 */
        notesBody.style.maxHeight = notesBody.scrollHeight + 'px';
        notesBody.offsetHeight;
        notesBody.classList.add('rq-ws-notes-sidebar__body--collapsed');
        notesSidebar.classList.add('rq-ws-notes-sidebar--collapsed');
        notesBody.style.maxHeight = '0';
      }

      spinToggle(notesToggle, isCollapsed ? '−' : '+');
      notesToggle.setAttribute('aria-label', isCollapsed ? 'Hide notes' : 'Show notes');
      notesToggle.setAttribute('title', isCollapsed ? 'Hide notes' : 'Show notes');
    });
  }

  /* ── Set notes textarea height once on load (matches customer card height) ── */
  (function() {
    var custSection = wrap.querySelector('.rq-ws-customer');
    var notesPanel = wrap.querySelector('.rq-ws-notes-sidebar__panel');
    var notesTextarea = wrap.querySelector('.rq-ws-notes-sidebar__textarea');
    if (!custSection || !notesPanel || !notesTextarea) return;
    setTimeout(function() {
      var h = custSection.offsetHeight;
      if (h < 50) return;
      var headerH = notesPanel.querySelector('.rq-ws-notes-sidebar__header').offsetHeight || 41;
      var textareaH = Math.max(h - headerH - 24, 140);
      notesTextarea.style.minHeight = textareaH + 'px';
    }, 100);
  })();

  // Exports
  Q.customWrap = customWrap;
})();
